const ENABLED = "enabled";

export const hasAdminAccess = user =>
  user?.profile === "admin" || user?.super === true;

export const canAccessTalkAi = user =>
  hasAdminAccess(user) || user?.allowTalkAi === ENABLED;

export const canAccessKnowledgeBase = user =>
  hasAdminAccess(user) || user?.allowKnowledgeBase === ENABLED;

